import HttpClient from './http-client';
import URL from './url';

export default class VideoSchoolAssignmentApi {

    static createVideoSchoolAssignment(payload) {
        return HttpClient.post(URL.BASE_URL + URL.VIDEO_SCHOOL_ASSIGNMENT, null, payload);
    }

    static createVideoSchoolAssignmentUsingMobileNumber(payload) {
        return HttpClient.post(URL.BASE_URL + URL.VIDEO_SCHOOL_ASSIGNMENT_USING_MOBILE_NUMBER, null, payload);
    }

    static createVideoSchoolAssignmentToTeacherUsingMobileNumber(payload) {
        return HttpClient.post(URL.BASE_URL + URL.VIDEO_SCHOOL_ASSIGNMENT_TO_TEACHER_USING_MOBILE_NUMBER, null, payload);
    }

    

}